import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { devices } from '../../utilities/responsive';

export const ButtonAsLink = styled(Link)`
    border-radius: 30px;
    color: var(--white);
    font-size: 1.6rem;
    font-weight: 600;
    padding: 10px;
    margin: 10px 0;
    text-align: center;
    width: calc(50% - 10px);

    @media ${devices.tabletPortrait} {
        margin: 5px 0;
    }

    &.btn-news {
        background-color: var(--eyebrow-color);

        &:hover {
            background-color: #1fb7d6;
        }
    }

    &.btn-technology {
        background-color: var(--heavenly);

        &:hover {
            background-color: #17a5eb;
        }
    }

    &.btn-digital {
        background-color: var(--azure);

        &:hover {
            background-color: #4068ff;
        }
    }

    &.btn-case-study {
        background-color: var(--primary);

        &:hover {
            background-color: #546cf7;
        }
    }
`;